import { FormControl, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { CustomConfig } from '@app/utils/toaster.config';
import { ToastrService } from 'ngx-toastr';

export class UlaEmailControl extends FormControl {

  public toaster: ToastrService;
  public toasterHeader: string;

  public get errorCallback(): () => void {
    return () => this.toaster.error('The email service is offline', this.toasterHeader, CustomConfig);
  };

  public constructor(formState?: any,
                     validator?: ValidatorFn | ValidatorFn[],
                     asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[]) {
    super(formState, validator, asyncValidator);
  }


}
